import { ArrowRight } from 'lucide-react';

export default function FeaturedInsight() {
  return null;
}